import { configureStore } from "@reduxjs/toolkit";

// User slices
import userReducer from "./features/userSlice";
import getAllUsersReducer from "./features/getAllUsersSlice";
import addUserReducer from "./features/addUserSlice";
import editUserReducer from "./features/editUserSlice";
import deleteUserReducer from "./features/deleteUserSlice";

// VM slices
import getAllAWSVmsReducer from "./features/vm/getAllAWSVmsSlice";
import updateAWSVmStateReducer from "./features/vm/updateAWSVmStateSlice";
import getAWSVmStatusReducer from "./features/vm/getAWSVmStatusSlice";
import updateAWSVmScheduleReducer from "./features/vm/updateAWSVmScheduleSlice";
import getAWSVmLogsReducer from "./features/vm/getAWSVmLogsSlice";

// DB slices
import getAllAWSDBsReducer from "./features/db/getAllAWSDBsSlice";
import updateAWSDBStateReducer from "./features/db/updateAWSDBStateSlice";
import getAWSDBStatusReducer from "./features/db/getAWSDBStatusSlice";
import updateAWSDBScheduleReducer from "./features/db/updateAWSDbScheduleSlice";
import getAWSDBLogsReducer from "./features/db/getAWSDbLogsSlice";
import getAllAWSAccountsReducer  from "./features/getAllAWSAccounts";
import deleteCronReducer from "./features/deleteCronSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    getAllUsers: getAllUsersReducer,
    addUser: addUserReducer,
    editUser: editUserReducer,
    deleteUser: deleteUserReducer,
    getAllAWSAccounts:getAllAWSAccountsReducer,

    // VM reducers
    getAllAWSVms: getAllAWSVmsReducer,
    updateAWSVmState: updateAWSVmStateReducer,
    getAWSVmStatus: getAWSVmStatusReducer,
    updateAWSVmSchedule: updateAWSVmScheduleReducer,
    getAWSVmLogs: getAWSVmLogsReducer,

    // DB reducers
    getAllAWSDBs: getAllAWSDBsReducer,
    updateAWSDBState: updateAWSDBStateReducer,
    getAWSDBStatus: getAWSDBStatusReducer,
    updateAWSDBSchedule: updateAWSDBScheduleReducer,
    getAWSDBLogs: getAWSDBLogsReducer,
    deleteCron:deleteCronReducer,
  },
});
